import { FormGroup } from '@angular/forms';
import { ModelForm } from './form-helpers.model';
import { PaginationForm } from './pagination.model';
import { SelectData } from './select-input.model';

export interface OpenedMovesFilter {
  fundo: SelectData[];
  arquivo: SelectData[];
  tipoMovimento: SelectData;
  seuNumero: string;
  numDocumento: string;
  valorTitulo: string;
  dataMovimentoInicio: Date;
  dataMovimentoFim: Date;
  dataVencimentoInicio: Date;
  dataVencimentoFim: Date;
  dataImportacao: Date;
  conciliado: boolean;
}
